<template>
  <div >
   <v2index></v2index>
  </div>
</template>

<script>
import index from '@/view/index/index.vue'
import v2index from '@/view/v2/index/index.vue'
export default {
  name: 'mainCenterv2',
	components: {
		'index':index,
		v2index:v2index
	}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/view/mainCenterv2.vue